<template>
	<AgItem :rowData="confirmations"
			:columnDefs="columnDefs"
			min-height="164px"
			height-type="matchRows"
	/>
</template>

<script>
import AgItem from "@/components/templates/agGrid/AgItem";
import {asLocalizedDate, asMoneyAmount} from "@/components/templates/agGrid/formatter/valueFormatters";

export default {
	props: {
		confirmations: { type: Array, default: [] },
	},
	components: {
		AgItem,
	},
	data() {
		return {
			columnDefs: [],
		};
	},
	beforeMount() {
		this.setColumnDefs();
	},
	methods: {
		setColumnDefs() {
			this.columnDefs = [
				{
					headerName: this.$t("common.amount"),
					headerClass: "align-right",
					field: "amount",
					cellStyle: {'justify-content': 'flex-end'},
					valueFormatter: asMoneyAmount()
				},
				{
					headerName: this.$t("common.dueDate"),
					field: "dueDate",
					valueFormatter: asLocalizedDate()
				},
				{
					headerName: this.$t("common.settlementPrice"),
					headerClass: "align-right",
					field: "settlementPrice",
					cellStyle: {'justify-content': 'flex-end'},
					valueFormatter: asMoneyAmount()
				},
				{
					headerName: this.$t("common.actions"),
					minWidth: 120,
					maxWidth: 120,
					cellRendererFramework: "AllInvestmentsRevolvingPutOptionsAssignmentConfirmationsTableOperation",
					cellRendererParams: {
						confirmAssignment: this.confirmAssignment
					}
				},
			]
		},
		confirmAssignment(data) {
			this.$emit("confirm-assignment", data);
		}
	},
};
</script>